import { h, render, Component } from 'preact'; // eslint-disable-line no-unused-vars

export default () => {
  Array.from(document.getElementsByTagName('EmailCircleIcon')).forEach((el) => {
    el.setAttribute('class', 'icon-wrapper');
    render((
      <svg className="connect__icon icon icon__email-circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130 130">
        <circle className="circle" cx="65" cy="65" r="63"/>
        <circle className="circle circle__inner" cx="65" cy="65" r="60"/>
        <path className="foreground" d="M38.74,45.21V84.6H91V45.21ZM66.57,67.45a2.51,2.51,0,0,1-3.32,0L43.81,48.26H86.13Zm-11-2.61L42,79.42v-28Zm2.56,2.59L60.66,70a6.15,6.15,0,0,0,8.48,0l2.5-2.51,13,14.15H44.76Zm16.08-2.51,13.51-13V79.61Z"/>
      </svg>
    ), el);
  });
};
